import {
  GET_TRADE_ORDERS,
  GET_TRADE_ORDERS_SUCCESS,
  GET_TRADE_ORDERS_FAILURE,
} from "../actionTypes";

export const getTradeOrders = (payload) => ({
  type: GET_TRADE_ORDERS,
  payload,
});

export const getTradeOrdersSuccess = (payload) => ({
  type: GET_TRADE_ORDERS_SUCCESS,
  payload,
});

export const getTradeOrdersFailure = () => ({
  type: GET_TRADE_ORDERS_FAILURE,
});